/**
 * 判断是否是移动端环境（Android / iOS）
 */
export function isMobileNavigator(): boolean {
  const userAgent = navigator.userAgent;
  const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
  const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

  return isAndroid || isIOS;
}
